<template>
  <div class="page-wrapper">
    <HeaderComponent />
    <div class="page-content">
      <AppBreadcrumb :items="[{ label: 'Bosh sahifa', to: '/' }, { label: 'Admin Panel' }]" />

      <div v-if="loading" class="loading-box"><a-spin size="large" /><p>Yuklanmoqda...</p></div>

      <template v-else>
        <!-- KPI Cards -->
        <div class="kpi-grid">
          <div class="kpi-card kpi-blue">
            <div class="kpi-icon">👥</div>
            <div class="kpi-info">
              <span class="kpi-value">{{ data.users?.total || 0 }}</span>
              <span class="kpi-label">Jami foydalanuvchilar</span>
            </div>
          </div>
          <div class="kpi-card kpi-green">
            <div class="kpi-icon">🟢</div>
            <div class="kpi-info">
              <span class="kpi-value">{{ data.users?.active_today || 0 }}</span>
              <span class="kpi-label">Bugun faol</span>
            </div>
          </div>
          <div class="kpi-card kpi-amber">
            <div class="kpi-icon">💎</div>
            <div class="kpi-info">
              <span class="kpi-value">{{ data.premium?.total || 0 }}</span>
              <span class="kpi-label">Premium foydalanuvchilar</span>
            </div>
          </div>
          <div class="kpi-card kpi-violet">
            <div class="kpi-icon">📝</div>
            <div class="kpi-info">
              <span class="kpi-value">{{ data.tests?.today_count || 0 }}</span>
              <span class="kpi-label">Bugun ishlangan testlar</span>
            </div>
          </div>
          <div class="kpi-card kpi-rose">
            <div class="kpi-icon">⚠️</div>
            <div class="kpi-info">
              <span class="kpi-value">{{ data.premium?.expiring_soon || 0 }}</span>
              <span class="kpi-label">Premium tugayotgan (7 kun)</span>
            </div>
          </div>
          <div class="kpi-card kpi-red">
            <div class="kpi-icon">🚫</div>
            <div class="kpi-info">
              <span class="kpi-value">{{ data.premium?.expired || 0 }}</span>
              <span class="kpi-label">Premium tugagan</span>
            </div>
          </div>
        </div>

        <!-- Content Grid -->
        <div class="admin-grid">
          <!-- Premium Users Table -->
          <div class="admin-panel">
            <h3 class="panel-title">💎 Premium foydalanuvchilar</h3>
            <div class="table-wrap">
              <table class="admin-table">
                <thead>
                  <tr><th>#</th><th>Foydalanuvchi</th><th>Ism</th><th>Tugash sanasi</th><th>Qoldi</th><th>Holat</th></tr>
                </thead>
                <tbody>
                  <tr v-for="(u, i) in (data.premium?.users || [])" :key="u.user_id">
                    <td>{{ i + 1 }}</td>
                    <td class="td-user">{{ u.username }}</td>
                    <td>{{ u.full_name || '—' }}</td>
                    <td>{{ formatDate(u.premium_until) }}</td>
                    <td><span :class="daysClass(u.days_left)">{{ u.days_left != null ? u.days_left + ' kun' : '—' }}</span></td>
                    <td><span class="status-badge" :class="u.is_expired ? 'st-red' : 'st-green'">{{ u.is_expired ? 'Tugagan' : 'Faol' }}</span></td>
                  </tr>
                  <tr v-if="!(data.premium?.users || []).length"><td colspan="6" class="td-empty">Ma'lumot yo'q</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Top Active Users -->
          <div class="admin-panel">
            <h3 class="panel-title">🏆 Eng faol foydalanuvchilar (7 kun)</h3>
            <div class="table-wrap">
              <table class="admin-table">
                <thead><tr><th>#</th><th>Foydalanuvchi</th><th>Ism</th><th>Testlar soni</th></tr></thead>
                <tbody>
                  <tr v-for="(u, i) in (data.users?.top_active || [])" :key="u.user__id">
                    <td><span class="rank-badge" :class="'rank-' + (i+1)">{{ i + 1 }}</span></td>
                    <td>{{ u.user__phone || '—' }}</td>
                    <td>{{ u.user__full_name || '—' }}</td>
                    <td><strong>{{ u.test_count }}</strong></td>
                  </tr>
                  <tr v-if="!(data.users?.top_active || []).length"><td colspan="4" class="td-empty">Ma'lumot yo'q</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Hardest Questions -->
          <div class="admin-panel full-width">
            <h3 class="panel-title">🔥 Eng qiyin savollar (Top 10)</h3>
            <div class="table-wrap">
              <table class="admin-table">
                <thead><tr><th>#</th><th>ID</th><th>Savol matni</th><th>Xato javoblar soni</th></tr></thead>
                <tbody>
                  <tr v-for="(q, i) in (data.tests?.hardest_questions || [])" :key="q.question__id">
                    <td>{{ i + 1 }}</td>
                    <td class="td-id">#{{ q.question__id }}</td>
                    <td class="td-question">{{ q.question__text }}</td>
                    <td><span class="wrong-count">{{ q.wrong_count }}</span></td>
                  </tr>
                  <tr v-if="!(data.tests?.hardest_questions || []).length"><td colspan="4" class="td-empty">Ma'lumot yo'q</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Topics Stats -->
          <div class="admin-panel full-width">
            <h3 class="panel-title">📚 Mavzular statistikasi</h3>
            <div class="topics-stats-grid">
              <div v-for="t in (data.topics || [])" :key="t.id" class="topic-stat-card" :class="'tsc-' + t.color">
                <div class="tsc-count">{{ t.question_count }}</div>
                <div class="tsc-name">{{ t.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent.vue'
import AppBreadcrumb from '../components/AppBreadcrumb.vue'
import api from '@/api/axios'

export default {
  name: 'AdminDashboardView',
  components: { HeaderComponent, AppBreadcrumb },
  data() { return { loading: true, data: {} } },
  async mounted() {
    try {
      const res = await api.get('/v1/admin-dashboard/')
      this.data = res.data || {}
    } catch(e) {
      console.error('Admin dashboard error:', e)
    } finally { this.loading = false }
  },
  methods: {
    formatDate(d) {
      if (!d) return '—'
      return new Date(d).toLocaleDateString('uz-UZ', { year:'numeric', month:'short', day:'numeric' })
    },
    daysClass(days) {
      if (days == null) return ''
      if (days < 0) return 'days-expired'
      if (days <= 3) return 'days-critical'
      if (days <= 7) return 'days-warning'
      return 'days-ok'
    }
  }
}
</script>

<style scoped>
.page-wrapper { min-height:100vh; display:flex; flex-direction:column; background:var(--bg) }
.page-content { flex:1; padding:0 24px 32px; max-width:1400px; margin:0 auto; width:100% }
.loading-box { display:flex; flex-direction:column; align-items:center; justify-content:center; min-height:400px; gap:16px }
.loading-box p { color:var(--text-soft); font-size:14px }

/* KPI Grid */
.kpi-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:16px; margin-top:16px }
.kpi-card { display:flex; align-items:center; gap:16px; padding:20px; border-radius:18px; background:var(--bg-card,#11243d); border:1px solid var(--border); position:relative; overflow:hidden; transition:transform .2s }
.kpi-card:hover { transform:translateY(-2px) }
.kpi-card::before { content:''; position:absolute; top:0; left:0; right:0; height:3px }
.kpi-blue::before { background:linear-gradient(90deg,#3b82f6,#60a5fa) }
.kpi-green::before { background:linear-gradient(90deg,#10b981,#34d399) }
.kpi-amber::before { background:linear-gradient(90deg,#f59e0b,#fbbf24) }
.kpi-violet::before { background:linear-gradient(90deg,#8b5cf6,#a78bfa) }
.kpi-rose::before { background:linear-gradient(90deg,#f43f5e,#fb7185) }
.kpi-red::before { background:linear-gradient(90deg,#ef4444,#f87171) }
.kpi-icon { font-size:32px }
.kpi-info { display:flex; flex-direction:column }
.kpi-value { font-size:28px; font-weight:800; color:var(--text); line-height:1.1 }
.kpi-label { font-size:12px; color:var(--text-soft); margin-top:4px }

/* Admin Grid */
.admin-grid { display:grid; grid-template-columns:1fr 1fr; gap:20px; margin-top:24px }
.admin-panel { background:var(--bg-card,#11243d); border:1px solid var(--border); border-radius:18px; padding:20px; overflow:hidden }
.admin-panel.full-width { grid-column:1/-1 }
.panel-title { font-size:16px; font-weight:700; color:var(--text); margin:0 0 16px; display:flex; align-items:center; gap:8px }

/* Table */
.table-wrap { overflow-x:auto }
.admin-table { width:100%; border-collapse:collapse; font-size:13px }
.admin-table th { text-align:left; padding:10px 12px; color:var(--text-soft); font-weight:600; font-size:11px; text-transform:uppercase; letter-spacing:.5px; border-bottom:1px solid var(--border); white-space:nowrap }
.admin-table td { padding:10px 12px; color:var(--text); border-bottom:1px solid rgba(255,255,255,.04) }
.admin-table tr:hover td { background:rgba(255,255,255,.02) }
.td-user { font-weight:600 }
.td-id { color:var(--text-soft); font-family:monospace }
.td-question { max-width:500px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis }
.td-empty { text-align:center; color:var(--text-soft); padding:24px!important; font-style:italic }

/* Status / Days */
.status-badge { padding:3px 10px; border-radius:20px; font-size:11px; font-weight:600 }
.st-green { background:rgba(16,185,129,.12); color:#10b981 }
.st-red { background:rgba(239,68,68,.12); color:#ef4444 }
.days-ok { color:#10b981; font-weight:600 }
.days-warning { color:#f59e0b; font-weight:600 }
.days-critical { color:#ef4444; font-weight:700 }
.days-expired { color:#ef4444; font-weight:700; text-decoration:line-through }
.wrong-count { background:rgba(239,68,68,.12); color:#ef4444; padding:3px 12px; border-radius:20px; font-weight:700; font-size:13px }
.rank-badge { display:inline-flex; align-items:center; justify-content:center; width:24px; height:24px; border-radius:50%; font-size:11px; font-weight:800; background:var(--border); color:var(--text) }
.rank-1 { background:linear-gradient(135deg,#f59e0b,#fbbf24); color:#000 }
.rank-2 { background:linear-gradient(135deg,#94a3b8,#cbd5e1); color:#000 }
.rank-3 { background:linear-gradient(135deg,#d97706,#f59e0b); color:#000 }

/* Topic Stats */
.topics-stats-grid { display:grid; grid-template-columns:repeat(5,1fr); gap:12px }
.topic-stat-card { padding:16px; border-radius:14px; background:rgba(255,255,255,.03); border:1px solid var(--border); text-align:center; transition:transform .2s }
.topic-stat-card:hover { transform:translateY(-2px) }
.tsc-count { font-size:28px; font-weight:800; color:var(--text); margin-bottom:6px }
.tsc-name { font-size:11px; color:var(--text-soft); line-height:1.3 }
.tsc-blue .tsc-count { color:#3b82f6 } .tsc-green .tsc-count { color:#10b981 }
.tsc-amber .tsc-count { color:#f59e0b } .tsc-rose .tsc-count { color:#f43f5e }
.tsc-indigo .tsc-count { color:#6366f1 } .tsc-cyan .tsc-count { color:#06b6d4 }
.tsc-teal .tsc-count { color:#14b8a6 } .tsc-orange .tsc-count { color:#f97316 }
.tsc-violet .tsc-count { color:#8b5cf6 }

@media(max-width:1024px) {
  .kpi-grid { grid-template-columns:repeat(2,1fr) }
  .admin-grid { grid-template-columns:1fr }
  .topics-stats-grid { grid-template-columns:repeat(3,1fr) }
}
@media(max-width:768px) {
  .page-content { padding:0 16px 24px }
  .kpi-grid { grid-template-columns:1fr 1fr; gap:12px }
  .kpi-card { padding:14px }
  .kpi-value { font-size:22px }
  .topics-stats-grid { grid-template-columns:repeat(2,1fr) }
}
</style>
